import i18next from 'i18next'
import { employerSide } from '../routerHistory'
import React from 'react'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core'
import classNames from 'classnames'
import { CheckBoxOutlineBlank } from '@material-ui/icons'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import mobileView from './mobile.utils'
import { IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { useSelector } from 'react-redux'
import { CalendarIcon } from '@mui/x-date-pickers'
import { getLocaleByLang } from '../form/components/inputs'
import LocationAutoCompleteField from './locationAutoCompleteField'

// text overflow middle for files uploaded name: long file name...uploaded.pdf
export const shrinkString = (originStr, maxChars, trailingCharCount) => {
  let shrinkedStr = originStr
  const shrinkedLength = maxChars - trailingCharCount - 3
  if (originStr.length > shrinkedLength) {
    const front = originStr.substr(0, shrinkedLength)
    const mid = '...'
    const end = originStr.substr(-trailingCharCount)
    shrinkedStr = front + mid + end
  }

  return shrinkedStr
}

export const formatTime = (time = '') => {
  return time ? time.slice(0, 5) : ''
}

export function formatTimeTo12Hour(time24) {
  // Split the input into hours and minutes
  const [hour, minutes] = time24.split(':')

  // Convert the hour to a number
  let hour12 = parseInt(hour, 10)

  // Determine AM or PM
  const ampm = hour12 >= 12 ? 'PM' : 'AM'

  // Convert hour to 12-hour format
  hour12 = hour12 % 12 || 12 // Convert 0 (midnight) and 12 (noon) correctly

  // Return formatted time
  return `${String(hour12).padStart(2, '0')}:${minutes} ${ampm}`
}

// Check work shift status
export function checkAllStatusIsSame(array, status) {
  return array.every((item) => item.workshift_status_entrepreneur === status)
}

// Convert salary model values to unit in invoice
export const salaryModel = (values) => {
  let salary_model

  if (values === 'Hourly rate') {
    salary_model = 'h'
  } else {
    salary_model = 'kpl'
  }

  return salary_model
}

export const contractFormKeys = [
  'salary_model',
  'amount',
  'payment_terms',
  'isExpensesIncluded',
  'assignment_type',
  'assignment_begins',
  'assignment_ends',
  'content_assignment',
  'additional_terms',
  'eng_lang'
]

export const filterKeys = (data, keys) => {
  return keys.reduce((acc, key) => {
    if (data.hasOwnProperty(key)) {
      acc[key] = data[key]
    }
    return acc
  }, {})
}

export function calculateHoursBetween(time1 = '', time2 = '') {
  if (time1 === null || time2 === null) {
    return ''
  }
  // Split the time strings into hours and minutes
  const [hours1, minutes1] = time1.split(':').map(Number)
  const [hours2, minutes2] = time2.split(':').map(Number)

  // Convert both times to minutes
  const totalMinutes1 = hours1 * 60 + minutes1
  const totalMinutes2 = hours2 * 60 + minutes2

  // Calculate the difference in minutes
  const differenceInMinutes = totalMinutes2 - totalMinutes1

  // Convert minutes back to hours
  const differenceInHours = differenceInMinutes / 60

  return differenceInHours.toFixed(2)
}

// Work shift
export const convertIntToState_ws = (status) => {
  switch (status) {
    case 0:
      return employerSide
        ? i18next.t('employer.ws_status.0')
        : i18next.t('ws_status.0') //'Pending acceptance'
    case 1:
      return employerSide
        ? i18next.t('employer.ws_status.1')
        : i18next.t('ws_status.1') //'Waiting for entry'
    case 2:
      return employerSide
        ? i18next.t('employer.ws_status.2')
        : i18next.t('ws_status.2') //'Actual hours have been entered and sent for approval'
    case 3:
      return employerSide
        ? i18next.t('employer.ws_status.3')
        : i18next.t('ws_status.3') //'Confirmed'
    case 4:
      return employerSide
        ? i18next.t('employer.ws_status.4')
        : i18next.t('ws_status.4') //'Entrepreneur rejected'
    case 5:
      return employerSide
        ? i18next.t('employer.ws_status.5')
        : i18next.t('ws_status.5') //'Entrepreneur accepted'
    case 6:
      return employerSide
        ? i18next.t('employer.ws_status.6')
        : i18next.t('ws_status.6') //'rejected'
  }
}

export const formatDate = (item) => {
  const date = new Date(item).setHours(0, 0, 0, 0)
  return new Date(date)
}

// x,xx
export const formatNumber = (value) => {
  const roundedValue = Math.round(value * 100) / 100
  return roundedValue.toFixed(2).replace('.', ',')
}

export async function fetchPdfAsBase64(url) {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    // Get the binary data
    const blob = await response.blob()

    // Convert binary data to Base64
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result.split(',')[1])
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
    return base64
  } catch (error) {
    console.error('Error fetching PDF:', error)
  }
}

export const processString = (input) => {
  return input
    .split(',')
    .map((part) => part.replace(/_/g, ' '))
    .join(', ')
}

export const formatUrl = (url) => {
  if (!url) return '' // Handle empty or undefined URLs
  return url.startsWith('http://') || url.startsWith('https://')
    ? url
    : `https://${url}`
}

export function searchAssignments(assignments, searchParams) {
  return assignments.filter((assignment) => {
    const {
      company_name,
      job_title,
      city_name,
      status,
      pinned,
      newAssignment
    } = searchParams

    const matchCompanyName = company_name
      ? assignment.company_name
          ?.toLowerCase()
          .includes(company_name.toLowerCase())
      : true

    const matchJobTitle = job_title
      ? assignment.job_title?.toLowerCase().includes(job_title.toLowerCase())
      : true

    const matchLocation = city_name
      ? assignment.location?.toLowerCase().includes(city_name.toLowerCase())
      : true

    const matchStatus = status === true ? assignment.status === 2 : true

    const matchPinned =
      pinned === true
        ? assignment.pinned_assignment_user === true ||
          assignment.pinned_application === true
        : true

    const matchNewAssignment =
      newAssignment === true ? assignment.is_assignment_viewed === 0 : 1

    return (
      matchCompanyName &&
      matchJobTitle &&
      matchLocation &&
      matchStatus &&
      matchPinned &&
      matchNewAssignment
    )
  })
}

export function searchApplications(assignments, searchParams) {
  return assignments.filter((assignment) => {
    const { company_name, job_title, city_name, status, pinned } = searchParams

    const matchCompanyName = company_name
      ? assignment.company_name
          ?.toLowerCase()
          .includes(company_name.toLowerCase())
      : true

    const matchJobTitle = job_title
      ? assignment.job_title?.toLowerCase().includes(job_title.toLowerCase())
      : true

    const matchLocation = city_name
      ? assignment.location?.toLowerCase().includes(city_name.toLowerCase())
      : true

    // const matchStatus = status
    //   ? status.toLowerCase() === 'application sent'
    //     ? !assignment.hasOwnProperty('agreement_status_entrepreneur')
    //     : assignment.agreement_status_entrepreneur?.toLowerCase() ===
    //       status.toLowerCase()
    //   : true

    const assignmentStatus = (
      assignment?.agreement_status_entrepreneur || ''
    ).toLowerCase()

    let matchStatus = true
    if (status) {
      const normalizedStatus = status.toLowerCase()

      if (normalizedStatus === 'application sent') {
        matchStatus = !assignment.hasOwnProperty(
          'agreement_status_entrepreneur'
        )
      } else if (normalizedStatus === 'offer sent by employer') {
        // match either 'pending' or 'offer sent by employer'
        matchStatus = ['pending', 'offer sent by employer'].includes(
          assignmentStatus
        )
      } else {
        matchStatus = assignmentStatus === normalizedStatus
      }
    }

    const matchPinned =
      pinned === true
        ? assignment.pinned_assignment_user === true ||
          assignment.pinned_application === true
        : true

    return (
      matchCompanyName &&
      matchJobTitle &&
      matchLocation &&
      matchStatus &&
      matchPinned
    )
  })
}

// Searh applications fields
const filterFieldStyle = { padding: '0 8px', width: mobileView ? '' : '200px' }
const labelStyle = { fontSize: '18px', marginTop: '30px' }

export const AssignmentFilters = ({
  t,
  filters,
  onChange,
  classes,
  resetSelectedPage
}) => {
  const handleChange = (field) => (e) => {
    resetSelectedPage()
    onChange({
      ...filters,
      [field]: !!e.target
        ? e?.target.type === 'checkbox'
          ? e.target.checked
          : e.target.value
        : e
    })
  }

  const handleSelect = (field) => (value) => {
    onChange({ ...filters, [field]: value })
  }

  return (
    <div className={classNames(classes.searchField)}>
      <div
        className={classNames(classes.filterFields)}
        style={mobileView ? { paddingBottom: 0 } : {}}
      >
        {/* Company */}
        <div style={filterFieldStyle}>
          <TextField
            label={t('assignment.label3')}
            value={filters.company_name}
            onChange={handleChange('company_name')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/* Job Title */}
        <div style={filterFieldStyle}>
          <TextField
            label={t('assignment.label1')}
            value={filters.job_title}
            onChange={handleChange('job_title')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/* Location */}
        <div style={filterFieldStyle}>
          <LocationAutoCompleteField
            label={t('assignment.label4')}
            value={filters.city_name}
            classes={classes}
            handleChange={handleChange}
            handleSelect={handleSelect}
            employerSide={false}
          />
        </div>

        {/* Status */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.status}
                  onChange={handleChange('status')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('assignmentStatus.2')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>

        {/* Pinned Checkbox */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.pinned}
                  onChange={handleChange('pinned')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('assignment.label15')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>

        {/* New assignments */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.newAssignment}
                  onChange={handleChange('newAssignment')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('assignment.label16')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>
      </div>
      <div className={classNames(classes.filterFields)}>
        {/* Page Size */}
        <div style={{ padding: '0 8px', width: '80px' }}>
          <FormControl fullWidth>
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('assignment.label9')}
            </InputLabel>
            <Select
              value={filters.pageSize}
              onChange={handleChange('pageSize')}
              className={classNames(classes.textField)}
            >
              {[10, 20, 50, 100].map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export const ApplicationFilters = ({
  t,
  filters,
  onChange,
  classes,
  statusOptions = [{ value: '', label: '' }],
  resetSelectedPage
}) => {
  const handleChange = (field) => (e) => {
    resetSelectedPage()
    onChange({
      ...filters,
      [field]: !!e.target
        ? e?.target.type === 'checkbox'
          ? e.target.checked
          : e.target.value
        : e
    })
  }

  const handleSelect = (field) => (value) => {
    onChange({ ...filters, [field]: value })
  }

  return (
    <div className={classNames(classes.searchField)}>
      <div
        className={classNames(classes.filterFields)}
        style={mobileView ? { paddingBottom: 0 } : {}}
      >
        {/* Company Name */}
        <div style={filterFieldStyle}>
          <TextField
            label={t('asiakkaat.company')}
            value={filters.company_name}
            onChange={handleChange('company_name')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>
        {/* Job Title */}
        <div style={filterFieldStyle}>
          <TextField
            label={t('assignment.label1')}
            value={filters.job_title}
            onChange={handleChange('job_title')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/*City name*/}
        <div style={filterFieldStyle}>
          <LocationAutoCompleteField
            label={t('assignment.label4')}
            value={filters.city_name}
            classes={classes}
            handleChange={handleChange}
            handleSelect={handleSelect}
            employerSide={false}
          />
        </div>

        {/* Status */}
        <div style={filterFieldStyle}>
          <FormControl
            fullWidth
            style={{ marginTop: mobileView ? '32px' : '' }}
          >
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('assignment.col9')}
            </InputLabel>
            <Select
              value={filters.status}
              onChange={handleChange('status')}
              className={classNames(classes.textField)}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Pinned Checkbox */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.pinned}
                  onChange={handleChange('pinned')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('application.pin')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>
      </div>
      <div className={classNames(classes.filterFields)}>
        {/* Page Size */}
        <div style={{ padding: '0 8px', width: '80px' }}>
          <FormControl fullWidth>
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('assignment.label9')}
            </InputLabel>
            <Select
              value={filters.pageSize}
              onChange={handleChange('pageSize')}
              className={classNames(classes.textField)}
            >
              {[10, 20, 50, 100].map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export function employer_searchAssignments(assignments, searchParams) {
  return assignments.filter((assignment) => {
    const { job_title, location, status, pinned } = searchParams

    const matchJobTitle = job_title
      ? assignment.job_title?.toLowerCase().includes(job_title.toLowerCase())
      : true

    const matchLocation = location
      ? assignment.location?.toLowerCase().includes(location.toLowerCase())
      : true

    const assignmentStatus = (
      assignment?.status_assignment ||
      assignment?.agreement_status_entrepreneur ||
      ''
    ).toLowerCase()

    let matchStatus = true
    if (status) {
      const normalizedStatus = status.toLowerCase()
      if (normalizedStatus === 'pending') {
        // match either 'pending' or 'Offer accepted by entrepreneur'
        matchStatus = [
          'pending',
          'offer accepted by entrepreneur',
          'offer sent by employer'
        ].includes(assignmentStatus)
      } else {
        matchStatus = assignmentStatus === normalizedStatus
      }
    }

    const matchPinned =
      pinned === true ? assignment.pinned_assignment === true : true

    return matchJobTitle && matchLocation && matchStatus && matchPinned
  })
}

export function employer_searchApplications(applications, searchParams) {
  return applications.filter((application) => {
    const { job_title, name, email, status, pinned } = searchParams

    const matchJobTitle = job_title
      ? application.job_title?.toLowerCase().includes(job_title.toLowerCase())
      : true

    const matchName = name
      ? application.firstname?.toLowerCase().includes(name.toLowerCase()) ||
        application.lastname?.toLowerCase().includes(name.toLowerCase()) ||
        (application.firstname + ' ' + application.lastname)
          ?.toLowerCase()
          .includes(name.toLowerCase())
      : true

    const matchEmail = email
      ? application?.offered_entrepreneur_email
        ? application.offered_entrepreneur_email
            ?.toLowerCase()
            .includes(email.toLowerCase())
        : application.email?.toLowerCase().includes(email.toLowerCase())
      : true

    const matchStatus = status
      ? application?.agreement_id
        ? application.agreement_status_entrepreneur
            ?.toLowerCase()
            .includes(status.toLowerCase())
        : application.application_status
            ?.toLowerCase()
            .includes(status.toLowerCase())
      : true

    const matchPinned =
      pinned === true
        ? application.pinned_applicant === true ||
          application.pinned_application === true
        : true

    return (
      matchJobTitle && matchName && matchEmail && matchStatus && matchPinned
    )
  })
}

export function searchWorkshifts(workshifts, searchParams) {
  return workshifts.filter((workshift) => {
    const {
      company_name,
      task_description,
      workshift_date,
      status,
      pinned,
      name,
      email
    } = searchParams

    const matchCompanyName = company_name?.trim()
      ? workshift?.company_name
          ?.toLowerCase()
          .includes(company_name.toLowerCase().trim())
      : true

    const matchTaskDescription = task_description?.trim()
      ? workshift?.task_description
          ?.toLowerCase()
          .includes(task_description.toLowerCase().trim())
      : true

    const matchWorkshiftDate = workshift_date
      ? formatDate(workshift?.workshift_date).getTime() ===
        formatDate(workshift_date).getTime()
      : true

    const matchStatus =
      status !== undefined && status !== ''
        ? workshift?.workshift_status_entrepreneur === Number(status)
        : true

    const matchPinned =
      pinned === true
        ? (workshift?.pinned_workshift || workshift?.pinned_workshift_user) ===
          true
        : true

    const matchName = name?.trim()
      ? workshift?.firstname
          ?.toLowerCase()
          .includes(name.toLowerCase().trim()) ||
        workshift?.lastname
          ?.toLowerCase()
          .includes(name.toLowerCase().trim()) ||
        (workshift?.firstname + ' ' + workshift?.lastname)
          ?.toLowerCase()
          .includes(name.toLowerCase().trim())
      : true
    const matchEmail = email?.trim()
      ? workshift?.offershift_to
          ?.toLowerCase()
          .includes(email.toLowerCase().trim())
      : true

    return (
      matchCompanyName &&
      matchTaskDescription &&
      matchWorkshiftDate &&
      matchStatus &&
      matchPinned &&
      matchName &&
      matchEmail
    )
  })
}

// Search work shift fields

export const WorkshiftFilters = ({
  t,
  filters,
  onChange,
  classes,
  statusOptions = [{ value: '', label: '' }],
  resetSelectedPage
}) => {
  const [open, setOpen] = React.useState(false)
  const handleChange = (field) => (e) => {
    resetSelectedPage()
    onChange({
      ...filters,
      [field]: e.target?.type === 'checkbox' ? e.target.checked : e.target.value
    })
  }

  const lang = useSelector((state) => state.language.lang)
  const locale = React.useMemo(() => getLocaleByLang(lang), [lang]) // Dynamically set locale

  return (
    <div className={classNames(classes.searchField)}>
      <div
        className={classNames(classes.filterFields)}
        style={mobileView ? { paddingBottom: 0 } : {}}
      >
        {/*company_name*/}
        <div style={filterFieldStyle}>
          <TextField
            label={t('workshift.col2')}
            value={filters.company_name}
            onChange={handleChange('company_name')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/*task_description*/}
        <div style={filterFieldStyle}>
          <TextField
            label={t('workshift.col1')}
            value={filters.task_description}
            onChange={handleChange('task_description')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/*Date*/}
        <div style={filterFieldStyle}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DatePicker
              open={open}
              onOpen={() => setOpen(true)}
              value={filters.workshift_date}
              onChange={(date) => {
                resetSelectedPage()
                onChange({
                  ...filters,
                  workshift_date: date
                })
              }}
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('workshift.col3')}
                </Typography>
              }
              onClose={() => {
                setOpen(false)
              }}
              InputLabelProps={{
                shrink: false, // <-- this keeps the label inside
                style: {
                  fontSize: '13px',
                  marginTop: '3px'
                }
              }}
              InputProps={{
                classes: {
                  input: classNames(classes.textField)
                }
              }}
              format={'dd.MM.yyyy'}
            />
          </MuiPickersUtilsProvider>
          {filters.workshift_date === null ? (
            <IconButton
              className={classes.clearFieldButton}
              onClick={() => {
                setOpen(true)
              }}
              style={{ color: '#44C0CC' }}
            >
              <CalendarIcon className={classes.clearIcon} />
            </IconButton>
          ) : (
            <IconButton
              className={classes.clearFieldButton}
              onClick={() => {
                resetSelectedPage()
                onChange({
                  ...filters,
                  workshift_date: null
                })
              }}
            >
              <Close className={classes.clearIcon} />
            </IconButton>
          )}
        </div>

        {/* Status */}
        <div style={filterFieldStyle}>
          <FormControl
            fullWidth
            style={{ marginTop: mobileView ? '32px' : '' }}
          >
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('workshift.col8')}
            </InputLabel>
            <Select
              value={filters.status}
              onChange={handleChange('status')}
              className={classNames(classes.textField)}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Pinned Checkbox */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.pinned}
                  onChange={handleChange('pinned')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('assignment.label15')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>
      </div>
      <div className={classNames(classes.filterFields)}>
        {/* Page Size */}
        <div style={{ padding: '0 8px', width: '80px' }}>
          <FormControl fullWidth>
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('assignment.label9')}
            </InputLabel>
            <Select
              value={filters.pageSize}
              onChange={handleChange('pageSize')}
              className={classNames(classes.textField)}
            >
              {[10, 20, 50, 100].map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export const getCompanyRatings = (data) => {
  const result = data.map((company) => {
    const ratings = company.workshifts
      .map((shift) => shift.entrepreneurs_rating)
      .filter((rating) => rating !== null && rating !== undefined)

    const totalRating = ratings.reduce((sum, rating) => sum + rating, 0)
    const averageRating = ratings.length
      ? (totalRating / ratings.length).toFixed(2)
      : ''

    return {
      company_name: company.company_name,
      average_rating: averageRating
    }
  })

  // Overall Summary
  const allRatings = data
    .flatMap((company) =>
      company.workshifts.map((shift) => shift.entrepreneurs_rating)
    )
    .filter((rating) => rating !== null && rating !== undefined)

  const totalRating = allRatings.reduce((sum, rating) => sum + rating, 0)
  const overallAverage = allRatings.length
    ? (totalRating / allRatings.length).toFixed(2)
    : ''

  const summary = {
    total_companies: data.length,
    overall_average_rating: overallAverage
  }

  return { result, summary }
}

export const generateProfileRatings = (ratingsArray) => {
  if (ratingsArray.length === 0) return ''
  return ratingsArray
    .map((item) => {
      return item.average_rating
        ? `${item.company_name} ${item.average_rating}`
        : item.company_name
    })
    .join(', ')
}

export const generateProfileRatingsToObject = (profileRatings) => {
  return profileRatings?.split(',').map((entry) => {
    const parts = entry.trim().split(' ')
    const last = parts[parts.length - 1]
    const rating = parseFloat(last)

    if (!isNaN(rating)) {
      return {
        company_name: parts.slice(0, -1).join(' '),
        average_rating: rating
      }
    } else {
      return {
        company_name: parts.join(' '),
        average_rating: ''
      }
    }
  })
}

export const summaryRatings = (ratingsArray) => {
  const ratedCompanies = ratingsArray?.filter(
    (item) => item.average_rating !== '' && !isNaN(item.average_rating)
  )
  const total_companies = ratingsArray.length

  if (ratedCompanies.length === 0) {
    return {
      total_companies,
      overall_average_rating: ''
    }
  }

  const sumRatings = ratedCompanies.reduce(
    (sum, item) => sum + parseFloat(item.average_rating),
    0
  )
  const overall_average_rating = (sumRatings / ratedCompanies.length).toFixed(2) // rounded to 2 decimals

  return {
    total_companies,
    overall_average_rating: parseFloat(overall_average_rating) // return as number not string
  }
}

// Rearrange pinned items on top of an array of objects
export function rearrangeByPinned(items, pinnedKey) {
  return items.sort((a, b) => (b[pinnedKey] ? 1 : 0) - (a[pinnedKey] ? 1 : 0))
}

export const convertPortfolioNameLinks = (portfolioNameLinks) => {
  if (!portfolioNameLinks || portfolioNameLinks.length === 0) return ''
  return portfolioNameLinks
    .map((item) => `${item.link_title},${item.link_url}`)
    .join(',')
}

export const convertPortfolioNameLinksToObject = (input = '') => {
  if (input === '' || input === null) {
    return []
  } else {
    const parts = input.split(',')
    const links = []

    for (let i = 0; i < parts.length; i += 2) {
      links.push({
        link_title: parts[i],
        link_url: parts[i + 1]
      })
    }
    return links
  }
}

export function createLinkArray(merged_porttitles = '', merged_urls = '') {
  const titles = merged_porttitles.split(',').map((title) => title.trim())
  const urls = merged_urls.split(',').map((url) => url.trim())

  return titles.map((title, index) => ({
    link_title: title || '',
    link_url: urls[index] || ''
  }))
}

export function convertToObjects(str = '') {
  if (!str) return []
  return str.split(',').map((link) => ({ FilePath: link.trim() }))
}

export const groupApplicationsByJob = (applications) => {
  return Object.values(
    applications.reduce((acc, application) => {
      const jobId = application.applied_job_id || application.assignment_job_id
      if (!acc[jobId]) {
        acc[jobId] = {
          applied_job_id: jobId,
          job_title: application.job_title,
          assignment_begins: application.assignment_begins,
          applications: []
        }
      }
      acc[jobId].applications.push(application)
      return acc
    }, {})
  )
}

export const windowPrompt = (msg) => {
  const confirm = window.confirm(msg)
  return confirm // return whether the user confirmed
}

export const contractContent = (endDate, eng_lang) => {
  return eng_lang
    ? [
        {
          BackgroundAndPurpose:
            "In this assignment agreement ('Assignment Agreement') the terms of the assignment performed by the Light Entrepreneur acting as an independent entrepreneur to the Customer, such as the content of the assignment, the Parties' responsibilities, obligations, and price, are agreed upon.",
          ContentAndDurationAssignment:
            endDate !== null && endDate !== undefined && endDate !== ''
              ? "This Assignment Agreement specifies the terms of the assignment performed by the Light Entrepreneur, such as the content of the assignment, the Parties' responsibilities, obligations, and price.<br /><br /> Description of the content of the assignment and the Parties' responsibilities, obligations, and any special requirements (qualifications, degrees, certifications, etc.) ('Assignment'):<br /><br /> [AssignmentContent]<br /><br /> The duration of the assignment is as follows:<br /><br /> The Assignment Agreement is valid for [AssignmentType] from [AssignmentBegins] to [AssignmentEnds]."
              : "This Assignment Agreement specifies the terms of the assignment performed by the Light Entrepreneur, such as the content of the assignment, the Parties' responsibilities, obligations, and price.<br /><br /> Description of the content of the assignment and the Parties' responsibilities, obligations, and any special requirements (qualifications, degrees, certifications, etc.) ('Assignment'):<br /><br /> [AssignmentContent]<br /><br /> The duration of the assignment is as follows:<br /><br /> The Assignment Agreement is valid for [AssignmentType] from [AssignmentBegins].",
          TimingAndReporting:
            endDate !== null && endDate !== undefined && endDate !== ''
              ? "The assignment mentioned in Section 3 starts on [AssignmentBegins] and ends on [AssignmentEnds].<br /><br /> At the Customer's request, the Light Entrepreneur is obliged to submit a written report, which contains at least an explanation of the time spent and the progress of the Assignment, as well as other appropriate and reasonable information requested by the Customer regarding the status of the Assignment."
              : "The assignment mentioned in Section 3 starts on [AssignmentBegins].<br /><br /> At the Customer's request, the Light Entrepreneur is obliged to submit a written report, which contains at least an explanation of the time spent and the progress of the Assignment, as well as other appropriate and reasonable information requested by the Customer regarding the status of the Assignment.",
          CompensationExpensesAndCosts:
            'The Customer pays the following compensation to the Light Entrepreneur for the performance of the Assignment following the Assignment Agreement:<br /><br /> [SalaryModel]<br /><br /> [Amount] € (+ALV)<br /><br /> [ExpenseFee]<br /><br /> The prices are always subject to the applicable value-added tax (VAT).<br /><br /> The compensation paid by the Customer to the Light Entrepreneur for the work they do, as well as any other payments made by the Customer to the Light Entrepreneur in connection with the work they do, such as expense reimbursements, are agreed between the Parties.',
          PaymentTermsAndInvoicing:
            'The payment term for the compensation related to the Assignment is [PaymentTerms] days net.<br /><br /> Interest on late payment follows the Interest Act (633/1982; amendments up to 32/2013 included).<br /><br /> The Parties mutually agree on the measures related to invoicing.',
          InsuranceAndQualifications:
            'The Light Entrepreneur is responsible for the insurance related to the assignment performed by the Light Entrepreneur and the work associated with it (e.g., YEL insurance). Furthermore, the Light Entrepreneur is accountable for possessing the necessary qualifications, certifications, and certificates essential for the successful execution of the assignment.<br /><br /> If invoicing for the completed work is conducted via Invosy Oy, the Light Entrepreneur is insured with accident, legal protection, and liability coverages through Fennia Insurance Company. This coverage extends to damages incurred following the terms and conditions outlined in the insurance policy. Liability insurance covers damages up to 1,000,000 euros, with a deductible of 1,200 euros. The payment ceiling for legal expenses is 30,000 euros, with a 15% deductible of the amount of the damage, a minimum of 600 euros. The insured amount for the foreign property under consideration is 25,000 euros, with a deductible of 1,200 euros.<br /><br /> It is important to note that the insurance does not extend to damages caused intentionally or through gross negligence. Additionally, if the nature of the work necessitates separate liability insurance under the provisions of the Occupational Accidents and Occupational Diseases Act, it remains the responsibility of the Light Entrepreneur to secure such coverage.',
          TerminationConditionsAgreement:
            'Unless otherwise agreed upon by the Parties, the Agreement terminates upon completing the Assignment.<br /><br /> Either Party has the right to terminate this Assignment Agreement due to a material breach by the other Party, provided that a remediable material breach is not rectified within 7 days following the written notice from the other Party regarding the material breach.',
          LimitationOfLiability:
            'Invosy Oy is not responsible for the responsibilities or obligations related to the performance of the Assignment.<br /><br /> The Parties are not liable for indirect damages caused by a breach of the Agreement. The limitation of liability does not apply to damages caused intentionally or by gross negligence.',
          AmendmentAndTransferAssignment:
            "Neither Party has the right to transfer this Assignment Agreement in whole or in part without the prior written consent of the other Party.<br /><br /> This Assignment Agreement can only be amended by the Parties' written agreement.",
          ForceMajeure:
            'If compliance with the terms outlined in this Assignment Agreement is impeded or unreasonably delayed due to force majeure, the affected Party shall be exempted from adhering to the terms of the Assignment Agreement for the duration of the impediment. Force majeure, in this context, encompasses circumstances such as war, requisition or expropriation for public needs, import or export bans, labor disputes, natural phenomena including thunderstorms, storms, fires, floods, water damage, damage caused by an external party to cables or similar infrastructure, overvoltage from the power grid, interruption of energy or other essential raw material supply, or any other unforeseen reasons beyond the contemplation of the Party at the time of entering into the Assignment Agreement, which the Party cannot prevent or mitigate.',
          ApplicableLawAndDisputeResolution:
            "This Assignment Agreement shall be governed by Finnish law, excluding its provisions on the choice of law.<br /><br /> The parties aim to resolve disagreements arising from this Assignment Agreement through mutual negotiations. If, with the help of negotiations, an agreement cannot be reached regarding the matter under dispute, the disagreements arising from this Assignment Agreement will be resolved [in the court of the defendant's domicile/determine other competent district courts, however, the mandatory consumer legislation must be taken into account.]"
        }
      ]
    : [
        {
          BackgroundAndPurpose:
            'Tässä toimeksiantosopimuksessa (”Toimeksiantosopimus”) sovitaan itsenäisenä yrittäjänä toimivan Kevytyrittäjän Tilaajalle suorittaman toimeksiannon suorittamisen ehdoista, kuten toimeksiannon sisällöstä, Osapuolten vastuista, velvoitteista ja hinnasta.',
          ContentAndDurationAssignment:
            endDate !== null && endDate !== undefined && endDate !== ''
              ? 'Tässä Toimeksiantosopimuksessa sovitaan Kevytyrittäjän suorittaman toimeksiannon suorittamisen ehdoista, kuten toimeksiannon sisällöstä, Osapuolten vastuista, velvoitteista ja hinnasta.<br /><br /> Kuvaus toimeksiannon sisällöstä ja Osapuolten vastuista sekä velvoitteista ja mahdollisista erityisvaatimuksista (pätevyydet, tutkinnot, sertifikaatit ym.) (”Toimeksianto”):<br /><br /> [AssignmentContent]<br /><br /> Toimeksiannon kesto määräytyy seuraavasti:<br /><br /> Toimeksiantosopimus on voimassa [AssignmentType] [AssignmentBegins]-[AssignmentEnds].'
              : 'Tässä Toimeksiantosopimuksessa sovitaan Kevytyrittäjän suorittaman toimeksiannon suorittamisen ehdoista, kuten toimeksiannon sisällöstä, Osapuolten vastuista, velvoitteista ja hinnasta.<br /><br /> Kuvaus toimeksiannon sisällöstä ja Osapuolten vastuista sekä velvoitteista ja mahdollisista erityisvaatimuksista (pätevyydet, tutkinnot, sertifikaatit ym.) (”Toimeksianto”):<br /><br /> [AssignmentContent]<br /><br /> Toimeksiannon kesto määräytyy seuraavasti:<br /><br /> Toimeksiantosopimus on voimassa [AssignmentType] [AssignmentBegins].',
          TimingAndReporting:
            endDate !== null && endDate !== undefined && endDate !== ''
              ? 'Kohdassa 3 mainittu Toimeksianto alkaa [AssignmentBegins] ja päättyy [AssignmentEnds].<br /><br /> Kevytyrittäjä on velvollinen Tilaajan pyynnöstä toimittamaan kirjallisen raportin, joka sisältää selvityksen vähintään käytetystä ajasta ja Toimeksiannon etenemisestä sekä muut Tilaajan pyytämät asianmukaiset ja kohtuulliset tiedot Toimeksiannon tilasta.'
              : 'Kohdassa 3 mainittu Toimeksianto alkaa [AssignmentBegins].<br /><br /> Kevytyrittäjä on velvollinen Tilaajan pyynnöstä toimittamaan kirjallisen raportin, joka sisältää selvityksen vähintään käytetystä ajasta ja Toimeksiannon etenemisestä sekä muut Tilaajan pyytämät asianmukaiset ja kohtuulliset tiedot Toimeksiannon tilasta.',
          CompensationExpensesAndCosts:
            'Tilaaja maksaa Toimeksiannon Toimeksiantosopimuksen mukaisesta suorittamisesta Kevytyrittäjälle seuraavan palkkion:<br /><br /> [SalaryModel]<br /><br /> [Amount] € (+ALV)<br /><br /> [ExpenseFee]<br /><br /> Hintoihin lisätään aina kulloinkin voimassa oleva arvonlisävero.<br /><br /> Sovitaan Tilaajan Kevytyrittäjälle tämän tekemästä työstä suorittaman palkkion suuruus sekä Tilaajan Kevytyrittäjälle tämän tekemään työhön liittyen suorittamat mahdolliset muut maksut, kuten kulukorvaukset.',
          PaymentTermsAndInvoicing:
            'Toimeksiantoa koskevan palkkion maksuehto on [PaymentTerms] päivän netto.<br /><br /> Viivästyskorko on korkolain (20.8.1982/633) mukainen.<br /><br /> Osapuolet sopivat keskenään laskutukseen liittyvistä toimenpiteistä.',
          InsuranceAndQualifications:
            'Kevytyrittäjä vastaa vakuutuksista, jotka liittyvät Kevytyrittäjän suorittamaan Toimeksiantoon ja siihen liittyvään työhön (esim. YEL-vakuutus). Lisäksi Kevytyrittäjä vastaa siitä, että sillä on Toimeksiannon suorittamiseen vaaditut tutkinnot, pätevyydet ja sertifikaatit.<br /><br /> Jos laskutus tehdystä työstä tapahtuu Invosy Oy:n kautta, Kevytyrittäjä on vakuutettu tapaturma-, oikeusturva- ja vastuuvakuutuksilla vakuutusyhtiö Fennian kautta, joka kattaa aiheutuneet vahingot vakuutusehtojen mukaisesti. Vastuuvakuutus kattaa vahingot 1 000 000 euroon asti, 1 200 euron omavastuulla. Oikeusturvan maksukattona toimii 30 000 euroa, 15% omavastuulla vahingon määrästä, minimi 600 euroa. Käsiteltävänä olevan vieraan omaisuuden vakuutusmäärä on 25 000 euroa, 1 200 euron omavastuulla.<br /><br /> Vakuutus ei korvaa vahinkoa, joka on aiheutettu tahallisesti tai omalla törkeällä huolimattomuudella, tai jos työ vaatii tämän lisäksi erillisiä työtapaturma- ja ammattitautilain mukaisia vastuuvakuutuksia.',
          TerminationConditionsAgreement:
            'Mikäli Osapuolet eivät ole muuta sopineet, sopimus päättyy Toimeksiannon tultua suoritetuksi.<br /><br /> Osapuolella on oikeus purkaa tämä Toimeksiantosopimus toisen Osapuolen olennaisen sopimusrikkomuksen johdosta, mikäli korjattavissa olevaa olennaista sopimusrikkomusta ei korjata 7 päivän kuluessa toisen Osapuolen kirjallisesta ilmoitusta olennaista sopimusrikkomusta koskien.',
          LimitationOfLiability:
            'Invosy Oy ei ole vastuussa toimeksiannon työsuoritteisiin liittyvistä vastuista tai velvoitteista.<br /><br /> Osapuolet eivät vastaa sopimusrikkomuksen aiheuttamista välillisistä vahingoista. Vastuunrajoitus ei koske tahallisesti tai törkeällä huolimattomuudella aiheutettuja vahinkoja.',
          AmendmentAndTransferAssignment:
            'Kummallakaan Osapuolella ei ole oikeutta siirtää tätä Toimeksiantopimusta kokonaan tai osaksi ilman toisen Osapuolen kirjallisesti antamaa etukäteissuostumusta.<br /><br /> Tätä Toimeksiantosopimusta voidaan muuttaa ainoastaan Osapuolten kirjallisella sopimuksella.',
          ForceMajeure:
            'Mikäli tämän Toimeksiantosopimuksen ehtojen noudattamisen estää tai sitä kohtuuttomasti viivästyttää ylivoimainen este, Osapuoli vapautuu Toimeksiantosopimuksen noudattamisesta esteen keston ajaksi. Ylivoimaisena esteenä pidetään sotaa, pakko-ottoa tai takavarikkoa julkiseen tarpeeseen, tuonti- ja vientikieltoa, työselkkausta, luonnonilmiötä, ukonilmaa, myrskyä, tulta, tulvaa ja vesivahinkoa, ulkopuolisen aiheuttamaa kaapeli- tms. vahinkoa, sähköverkosta tulevaa ylijännitettä, energian tai muun olennaisen raaka-aineen toimituksen keskeytystä, tai muuta syytä, jota Osapuoli ei ole Toimeksiantosopimusta tehdessään voinut ottaa huomioon eikä voi estää tai poistaa sen vaikutusta.<br />',
          ApplicableLawAndDisputeResolution:
            'Tähän Toimeksiantosopimukseen sovelletaan Suomen lakia, lukuun ottamatta sen lainvalintaa koskevia säännöksiä.<br /><br /> Osapuolet pyrkivät ensisijaisesti ratkaisemaan Toimeksiantosopimuksesta aiheutuvat erimielisyydet keskinäisin neuvotteluin. Mikäli neuvotteluiden avulla ei päästä yhteisymmärrykseen riidanalaista asiaa koskien, ratkaistaan Toimeksiantosopimuksesta aiheutuvat erimielisyydet [vastaajan kotipaikan tuomioistuimessa/määritä muu toimivaltainen käräjäoikeus, huomioitava kuitenkin kuluttajaa koskeva pakottava lainsäädäntö.]'
        }
      ]
}

// Filter assignments
// Merge data by assignment_id
// All assignments includes applied assignments as well
// So need to replace with updated data
export function mergeAssignments(allAssignments, appliedAssignments) {
  const appliedMap = new Map(
    appliedAssignments.map((item) => [item.assignment_id, item])
  )

  return allAssignments.map(
    (assignment) =>
      appliedMap.has(assignment.assignment_id)
        ? appliedMap.get(assignment.assignment_id) // Replace with updated data
        : assignment // Keep original if not in appliedAssignments
  )
}

// Update status data for assignments
export function updateStatusData(
  assignments,
  appliedAssignmentId,
  loggedMail
  // user_area_of_work
) {
  const updateAssignments = assignments.map((assignment) => {
    return appliedAssignmentId.includes(assignment.assignment_id) // Applied assignment
      ? { ...assignment, status: 3 }
      : assignment.entrepreneur_email === loggedMail
      ? // || // Recommended assignment
        //   (assignment?.entrepreneur_email &&
        //     assignment.entrepreneur_email.includes(loggedMail)) // Recommended assignment
        { ...assignment, status: 2 }
      : { ...assignment, status: 1 } // Other assignment
  })

  const filterAssignmentRows = updateAssignments.filter((assignment) => {
    return (
      // assignment.status === 3 || // Applied assignment
      (assignment.status === 1 && // Other assignment
        (assignment.entrepreneur_email === loggedMail || // Add this condition to prevent when there only one email the record show not be shown if email doesn't match logged in email
          assignment.entrepreneur_email === '' ||
          assignment.entrepreneur_email === null) &&
        // assignment.industry_type
        //   .split(',')
        //   .some((item) => user_area_of_work.includes(Number(item))) && // Check the item in industry that appear at user area of work
        new Date(assignment.last_date_of_application).setHours(0, 0, 0, 0) >=
          new Date().setHours(0, 0, 0, 0)) || // Check the last date of application
      (assignment.status === 2 && // Recommended assignment
        new Date(assignment.last_date_of_application).setHours(0, 0, 0, 0) >=
          new Date().setHours(0, 0, 0, 0))
    )
  })

  const groupedAssignmentRows = groupAssignmentsById(filterAssignmentRows)
  let uniqueAssignmentRows = []
  groupedAssignmentRows.forEach((assignment) => {
    uniqueAssignmentRows.push(
      assignment.assignments.find((el) => el.status === 2) ??
        assignment.assignments.find((el) => el.status === 1)
    )
  })

  return uniqueAssignmentRows
}

const groupAssignmentsById = (assignments) => {
  return Object.values(
    assignments.reduce((acc, assignment) => {
      const assignmentId = assignment.assignment_id
      if (!acc[assignmentId]) {
        acc[assignmentId] = {
          assignmentId: assignmentId,
          job_title: assignment.job_title,
          assignments: []
        }
      }
      acc[assignmentId].assignments.push(assignment)
      return acc
    }, {})
  )
}

export const groupWorkshiftById = (workshifts, status) => {
  return Object.values(
    workshifts.reduce((acc, workshift) => {
      const key = workshift.workshift_id
      if (!acc[key]) {
        acc[key] = {
          workshiftid: workshift.workshift_id,
          WorkShiftStatusEntrepreneur: status,
          workshiftitems: []
        }
      }
      acc[key].workshiftitems.push({
        workshiftitemid: workshift.workshift_itemid
      })
      return acc
    }, {})
  )
}
